import axios from "axios";

export default {
  namespaced: true,
  state: {
    subscriptions: [],
  },
  mutations: {
    setSubscriptions(state, data) {
      state.subscriptions = data.map((e) => e.values);
    },
  },
  actions: {
    async getSubscriptions({ commit }, mail) {
      try {
        const response = await axios.get(
          `${window.VUE_APP_API_HOST}/api/mailsub/byMail/${mail}`
        );
        commit("setSubscriptions", response.data);
      } catch (e) {
        commit("setSubscriptions", []);
      }
    },

    async subscribe({ commit }, payload) {
      await axios.post(`${window.VUE_APP_API_HOST}/api/mailSub`, payload);
      const response = await axios.get(
        `${window.VUE_APP_API_HOST}/api/mailsub/byMail/${payload.employeeMail}`
      );
      commit("setSubscriptions", response.data);
    },

    async unsubscribe({ state, commit }, subId) {
      await axios.delete(`${window.VUE_APP_API_HOST}/api/mailSub/${subId}`);

      const newSubscriptions = state.subscriptions.filter(
        (s) => s.id !== subId
      );

      commit(
        "setSubscriptions",
        newSubscriptions.map((m) => ({ values: m }))
      );
    },
  },
};
